import request from '@/utils/request'

const prefix = '/django_rest/job-poster-ambassador'

export default {
  uploadJobPosterAmbassador (file) {
    const fileData = new FormData()
    fileData.append('file', file)
    return request.post(`${prefix}/upload/`, fileData)
  },
  getJobPosterAmbassadorList () {
    return request.get(`${prefix}/`)
  },
  getJobPosterAmbassadorById (ambassadorId) {
    return request.get(`${prefix}/${ambassadorId}/`)
  },
  addJobPosterAmbassador (ambassadorInfo) {
    return request.post(`${prefix}/`, ambassadorInfo)
  },
  updateJobPosterAmbassador (ambassadorInfo) {
    return request.put(`${prefix}/${ambassadorInfo.id}/`, ambassadorInfo)
  },
  checkAccountIsAmbassador (params) {
    return request.get(`${prefix}/check-is-ambassador/`, { params })
  },
  uploadAmbassadorJobPoster (posterInfo) {
    return request.post(`${prefix}/upload-poster/`, posterInfo)
  },
  deleteAmbassadorJobPoster (companyId, ambassadorPosterId) {
    return request.delete(`${prefix}/${companyId}/ambassador-poster/${ambassadorPosterId}/`)
  }
}
